import React from 'react';
export function App() {
  return <div className="min-h-screen w-full bg-black flex items-center justify-center font-['Montserrat']" data-id="element-0">
      <div className="relative bg-red-600 rounded-2xl px-16 py-20 shadow-2xl shadow-red-900/50 border-4 border-red-500 text-center max-w-lg mx-4" data-id="element-1">
        {/* Sign post effect */}
        <div className="absolute -top-12 left-1/2 -translate-x-1/2 w-4 h-16 bg-red-800 rounded-t-md" data-id="element-2" />

        <h1 className="text-5xl md:text-7xl font-black text-white tracking-tight leading-none mb-6 drop-shadow-lg" data-id="element-3">
          DOMAIN
          <br data-id="element-4" />
          FOR SALE
        </h1>
        <p className="text-white/80 text-lg md:text-xl font-medium mb-6" data-id="element-5">
          If interested, call:
        </p>
        <a href="tel:3058779092" className="inline-block text-2xl md:text-3xl font-black text-white bg-red-800 hover:bg-red-700 px-6 py-3 rounded-lg transition-colors tracking-wide" data-id="element-6">
          (305) 877-9092
        </a>
      </div>
    </div>;
}